import { render } from "./BaseSendProjectReports.vue?vue&type=template&id=781c69b2"
import script from "./BaseSendProjectReports.vue?vue&type=script&lang=js"
export * from "./BaseSendProjectReports.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__